import React from 'react';
import styles from './ui.module.css';

export type PillTone = 'neutral' | 'positive' | 'warning' | 'critical' | 'info';

interface PillProps {
  tone?: PillTone;
  /** Solid fill with tabular figures — for dates, counts and freshness badges. */
  solid?: boolean;
  /** Drop the leading dot. */
  plain?: boolean;
  title?: string;
  children: React.ReactNode;
}

const TONE: Record<PillTone, string> = {
  neutral: styles.pillNeutral,
  positive: styles.pillPositive,
  warning: styles.pillWarning,
  critical: styles.pillCritical,
  info: styles.pillInfo,
};

/**
 * A state marker: matched / break / pending, fresh / stale. Tone carries
 * meaning, so never pick one for looks — `positive` means something is good,
 * not that it is green.
 */
const Pill: React.FC<PillProps> = ({ tone = 'neutral', solid, plain, title, children }) => (
  <span
    title={title}
    className={[styles.pill, TONE[tone], solid ? styles.pillSolid : '', plain ? styles.pillPlain : '']
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </span>
);

export default Pill;
